// AssessmentList.tsx
import React from "react";
import { Flex } from "antd";
import AssessmentCard from "../LMSComponent/AssesmentCard";

interface Assessment {
  id: string;
  name: string;
  is_lock: boolean;
  is_attempted: boolean;
  reattempt_enabled?: boolean;
}

interface AssessmentListProps {
  assessments: Assessment[];
  onAssesmentCardClick: (assessmentId: string) => void;
  onReattemptClick: (assessmentId: string) => void;
}

/**
 * AssessmentList displays a grid of assessment cards
 */
const AssessmentList: React.FC<AssessmentListProps> = ({
  assessments,
  onAssesmentCardClick,
  onReattemptClick,
}) => {
  // Helper function to determine the appropriate image source
  const getAssessmentImage = (
    is_lock: boolean,
    is_attempted: boolean
  ): string => {
    if (is_lock) {
      return "/images/assesment-lock.png";
    }
    return is_attempted
      ? "/images/assesment-complete.png"
      : "/images/assesment.png";
  };

  return (
    <Flex wrap="wrap" gap="16px" style={{ marginTop: "20px" }}>
      {assessments.map((assessment) => {
        const { id, name, is_lock, is_attempted, reattempt_enabled } =
          assessment;
        return (
          <AssessmentCard
            key={id}
            id={id}
            name={name}
            isLocked={is_lock}
            isComplete={is_attempted}
            isReattemptEnabled={reattempt_enabled}
            showToolTip
            onAssesmentCardClick={onAssesmentCardClick}
            onReattemptClick={onReattemptClick}
            imgSrc={getAssessmentImage(is_lock, is_attempted)}
          />
        );
      })}
    </Flex>
  );
};

export default AssessmentList;
